import { Module } from '@nestjs/common';
import { PrismaModule } from '../prisma/prisma.module';
import { ProductoEspecificacionesController } from './producto-especificaciones.controller';
import { ProductoEspecificacionesService } from './producto-especificaciones.service';

@Module({
  imports: [PrismaModule],
  controllers: [ProductoEspecificacionesController],
  providers: [ProductoEspecificacionesService],
  exports: [ProductoEspecificacionesService],
})
export class ProductoEspecificacionesModule {}
